import { createContext, useState } from "react";
import { useDispatch } from "react-redux";

import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "../../../redux/actions/loadingActions/loadingActions";
import { verifyPaymentService } from "../../../services/publicServices";

export const verifyPaymentPublicContext = createContext({
  payment: {},
  setPayment: () => {},
  message: "",
  setMessage: () => {},
  handleVerifyPayment: () => {},
});

const VerifyPaymentPublicContext = ({ children }) => {
  const dispatch = useDispatch();

  const [payment, setPayment] = useState({});
  const [message, setMessage] = useState("");

  // Verify Payment
  const handleVerifyPayment = async (authority) => {
    const objData = { authority };
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await verifyPaymentService(objData);
      if (status === 200) {
        setMessage(data?.resultMessage);
        setPayment(data.result.payment);
      }
    } catch ({ response }) {
      if (response && response.status) {
        setPayment(response.data?.result?.payment);
        setMessage(response.data.resultMessage);
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <verifyPaymentPublicContext.Provider
      value={{
        payment,
        setPayment,
        message,
        setMessage,
        handleVerifyPayment,
      }}
    >
      {children}
    </verifyPaymentPublicContext.Provider>
  );
};

export default VerifyPaymentPublicContext;
